import React, { useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { IconButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { ViewFlagHover, ViewFlagSelected } from '../../Icons';
import MapButton from '../Button';
import { setHomeBookmark, activateBookmark } from '../../../../redux/bookmark/Actions';
import { MAIN_MAP } from '../../../../redux/map/Constants';
import ViewBase from './ViewBase';

const BookmarkControl = ({ classes, dispatchSetHomeBookmark, dispatchActivateBookmark }) => {
    const [bookmarkPanelOpen, setBookmarkPanelOpen] = useState(false);

    const toggleBookmarkPanel = () => {
        setBookmarkPanelOpen(!bookmarkPanelOpen);
    };

    return (
        <>
            <MapButton
                onClick={toggleBookmarkPanel}
                className={`${!bookmarkPanelOpen && classes.hoverButton}`}
            >
                {bookmarkPanelOpen ? <ViewFlagSelected /> : <ViewFlagHover className={classes.hoverIcon} />}
            </MapButton>
            {bookmarkPanelOpen && (
                <ViewBase />
            )}
        </>
    );
};

const styles = (theme) => ({
    hoverIcon: {
        // '&:hover > path:first-child': {
        //     fill: theme.palette.secondary.light
        // }
    },
    hoverButton: {
        '& > span > svg > path:last-child': {
            fill: theme.palette.grey.variant3
        },
        '&:hover > span > svg > path:last-child': {
            fill: theme.palette.secondary.light
        },
        '&:hover > span > svg > path:first-child': {
            fill: theme.palette.grey.variant3
        }
    },
});

const mapStateToProps = (state) => ({
    layers: state.layers.layers,
    homeBookmarkId: state.bookmarkReducer.homeBookmarkId,
    bookmarks: state.bookmarkReducer.bookmarks
});

const mapDispatchToProps = (dispatch) => ({
    dispatchSetHomeBookmark: (id) => dispatch(setHomeBookmark(id)),
    dispatchActivateBookmark: (bookmark) => dispatch(activateBookmark(bookmark))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
)(BookmarkControl);
